/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step2_Seaweed_DescriptionInputs */



/**
* | output |
* | --- |
* | "Secure cloud storage" |
*
* @param {Spaces_Wizard_Step2_Seaweed_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step2_seaweed_description = /** @type {((inputs?: Spaces_Wizard_Step2_Seaweed_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step2_Seaweed_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sicherer Cloud-Speicher")
	return /** @type {LocalizedString} */ ("Secure cloud storage")
});